import { render, staticRenderFns } from "./LogManagement.vue?vue&type=template&id=06ca3cc0&scoped=true&"
import script from "./LogManagement.vue?vue&type=script&lang=js&"
export * from "./LogManagement.vue?vue&type=script&lang=js&"
import style0 from "./LogManagement.vue?vue&type=style&index=0&id=06ca3cc0&lang=scss&scoped=true&"
import style1 from "./LogManagement.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ca3cc0",
  null
  
)

export default component.exports